import { render, staticRenderFns } from "./temtmain.vue?vue&type=template&id=66a5e6b0&scoped=true&"
import script from "./temtmain.vue?vue&type=script&lang=js&"
export * from "./temtmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5e6b0",
  null
  
)

export default component.exports